import { render, staticRenderFns } from "./default.vue?vue&type=template&id=23aae06c"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomFormWrapper: require('/usr/src/nuxt-app/components/custom_forms/CustomFormWrapper.vue').default,HeaderCasa: require('/usr/src/nuxt-app/components/HeaderCasa.vue').default,HeaderCategory: require('/usr/src/nuxt-app/components/HeaderCategory.vue').default,HeaderTop: require('/usr/src/nuxt-app/components/header/Tertiary/HeaderTop.vue').default,Navbar: require('/usr/src/nuxt-app/components/Navbar.vue').default,HeaderTertiary: require('/usr/src/nuxt-app/components/header/Tertiary/HeaderTertiary.vue').default,HeaderEcom: require('/usr/src/nuxt-app/components/HeaderEcom.vue').default,HeaderEcomBzodUa: require('/usr/src/nuxt-app/components/HeaderEcomBzodUa.vue').default,Header: require('/usr/src/nuxt-app/components/Header.vue').default,EcomSubscription: require('/usr/src/nuxt-app/components/EcomSubscription.vue').default,Footer: require('/usr/src/nuxt-app/components/footer/Footer.vue').default,FooterMobile: require('/usr/src/nuxt-app/components/footer/FooterMobile.vue').default,MenuItemsMobile: require('/usr/src/nuxt-app/components/MenuItemsMobile.vue').default})
